// GDPR
(function () {
  const GA = 'UA-21442134-1';

  const loadScript = (u, c) => {
    let d = document, t = 'script',
      o = d.createElement(t),
      s = d.getElementsByTagName(t)[0];
    o.src = u;
    if (c) { o.addEventListener('load', function (e) { c(null, e); }, false); }
    s.parentNode.insertBefore(o, s);
  };

  const enableEmbeds = () => {
    Array.from(document.querySelectorAll('iframe[data-src]')).forEach((iframe) => iframe.setAttribute('src', iframe.getAttribute('data-src')));
  };

  const disableEmbeds = () => {
    Array.from(document.querySelectorAll('iframe[data-src]')).forEach((iframe) => iframe.removeAttribute('src'));
  };

  const enableTracking = () => {
    delete window['ga-disable-' + GA];
    if (!window.dataLayer) {
      loadScript('https://www.googletagmanager.com/gtag/js?id=' + GA, () => {
        window.dataLayer = window.dataLayer || [];
        function gtag() { dataLayer.push(arguments); }
        gtag('js', new Date());
        gtag('config', GA, { 'anonymize_ip': true });
      });
    }
  };

  const disableTracking = () => {
    window['ga-disable-' + GA] = true;
  };

  window.addEventListener('load', () => {
    cookieconsent.initialise({
      palette: {
        popup: {
          background: '#d2232a',
          text: '#ffffff'
        },
        button: {
          background: '#ffffff',
          text: '#d2232a'
        }
      },
      theme: 'classic', // edgeless
      position: 'bottom-left', // bottom
      type: 'opt-in',
      content: {
        message: 'En poursuivant votre navigation, vous acceptez l’utilisation de services tiers pouvant installer des cookies.',
        dismiss: 'OK',
        allow: 'Accepter',
        deny: 'Refuser',
        link: 'En savoir plus',
        href: '/politique-de-confidentialite/',
        close: '&#x274c;',
        policy: '🍪 Cookies',
        target: '_self',
      },
      revokable: true,
      onInitialise(status) {
        const type = this.options.type;
        const didConsent = this.hasConsented();
        if (type == 'opt-in' && didConsent) {
          enableTracking();
          enableEmbeds();
        }
        if (type == 'opt-out' && !didConsent) {
          disableTracking();
          disableEmbeds();
        }
      },
      onStatusChange(status, chosenBefore) {
        const type = this.options.type;
        const didConsent = this.hasConsented();
        if (type == 'opt-in' && didConsent) {
          enableTracking();
          enableEmbeds();
        }
        if (type == 'opt-out' && !didConsent) {
          disableTracking();
          disableEmbeds();
        }
      },
      onRevokeChoice() {
        const type = this.options.type;
        if (type == 'opt-in') {
          disableTracking();
          disableEmbeds();
        }
        if (type == 'opt-out') {
          enableTracking();
          enableEmbeds();
        }
      }
    }, (popup) => {
      Array.from(document.querySelectorAll('[href="#gdpr"]')).forEach((link) => {
        link.addEventListener('click', (event) => {
          event.preventDefault();
          if (popup.isOpen()) {
            popup.setStatus(cookieconsent.status.allow);
            popup.close();
          } else {
            popup.open();
          }
        });
      });
    });
  });
})();
